/*
  ================================================================
  Wat:    Verwijder automatisch elke Tuinmaximaal-product die in
          de winkelwagen belandt via een directe /cart/add-URL,
          een cart-permalink (?items[]=variant_id=X) of een API-call
          die de theme-knoppen omzeilt.
  Hoe:    1) Bij pagina-load: roep /cart.js aan, controleer per regel
             of vendor === 'Tuinmaximaal', verwijder die regels.
          2) Onderschep window.fetch en XMLHttpRequest. Bij een call
             naar /cart/add* of /cart/update* wordt na afloop een
             nieuwe controle uitgevoerd.
  Scope:  Hele storefront (theme.liquid laadt dit in <head>).
  Undo:   Verwijder dit asset en de <script>-regel uit theme.liquid.
  ================================================================
*/
(function () {
  var BLOCKED_VENDOR = 'Tuinmaximaal';
  var checking = false;

  function removeBadItems() {
    if (checking) return;
    checking = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart.items || []).filter(function (i) {
          return i.vendor === BLOCKED_VENDOR;
        });
        if (!bad.length) { checking = false; return; }
        var updates = {};
        bad.forEach(function (i) { updates[i.key] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          checking = false;
          if (window.location.pathname.indexOf('/cart') === 0) {
            window.location.reload();
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
      })
      .catch(function () { checking = false; });
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = '';
    if (arguments[0]) url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0].url || '');
    var p = origFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/update') !== -1) {
      p.then(function () { setTimeout(removeBadItems, 150); });
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/update') !== -1)) {
      this.addEventListener('load', function () { setTimeout(removeBadItems, 150); });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeBadItems);
  } else {
    removeBadItems();
  }
})();
